// Styles
let themeStyles = {
  fontFamily: ["Sailec", "sans-serif"],
  fontFamily_secondary: ["Circular Std", "Open Sans", "sans-serif"],

  title_grey: "#676767",

  light_background: "#F3F4F9",
  blue_background: "#4AD4F0",
  dark_background: "#000000",
  modal_background: "rgba(32, 31, 31, 0.95)",
  border_color: "#F5F5F5",
  horizontal_rule_color: '#979797',

  even_table_background: "#F3F2F7",
  table_row_hover_background: "rgba(95,241,11,0.1)",

  purple: "#6F43D6",
  teal: "#4DD3C3",
  green: "#7FFF24",
  orange: "#FF4E44",
  blue: "#2B00F7",
  red: "#F10B63",
  yellow: "#FFC00D",

  black: "#000000",
  offblack: "#201F1F",
  darker_grey: "#505050",
  dark_grey: "#4A4A4A",
  grey: "#9B9B9B",
  grey_2: '#D4D4D8',
  light_grey: "#D1D3D4",
  lighter_grey: "#E6E7E8",
  white: "#FFFFFF",

  facebook: "#3B5998",

  container_width: 1180,
  margin: 15,
  margin_width: 100,
  navBarHeight: 80,
  tabBarHeight: 40,
  popover_distance_from_bottom: 75,

  mobile_query: '@media (max-width: 600px)',
  small_screen_query: '@media (max-width: 1300px)',

  post_text_fontSize: 14,
  post_text_lineHeight: 25,
};

let globals = {
  primary: themeStyles.yellow,
  secondary: themeStyles.orange,
};

let fonts = {
  text_color: themeStyles.darker_grey,
};

let player = {
  enabled: true,
  height: 70, // 70
  zIndex: 100,
  volume: {
    color: themeStyles.grey_2,
    width: 100,
    thickness: 2,
    played_color: globals.primary,
  },
  progress: {
    color: themeStyles.grey_2,
    width: 450,
    thickness: 2,
    played_color: globals.primary,
  },
  current_track: {
    width: 250,
  },
};

let navigation = {
  height: 80,
  zIndex: 100,
  link_fontFamily: ["Open Sans", "sans-serif"],
  link_color: themeStyles.offblack,
  link_hover_color: globals.primary,
  link_styles: {
    fontWeight: 600,
    textDecoration: "none",
    fontSize: 16,
  },
};

let featured_article_slider = {
  config: {
    arrows: false,
    draggable: false,
    dots: true,
    fade: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: false,
    dotsClass: 'featured-dots'
  },
  width: '100vw',
  height: 662,
};

let header_slider = {
  config: {
    arrows: false,
    draggable: false,
    dots: false,
    fade: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: false,
    verticalSwiping: false,
    dotsClass: 'header-slider-dots'
  },
  width: '100vw',
  height: 662,
};

// Export all theme config, plus values dependent on those from above objects
export const Theme = Object.assign({}, themeStyles, fonts, globals, {
  featured_article_slider: featured_article_slider,
  header_slider: header_slider,
  player: player,
  navigation: navigation
});



// WEBPACK FOOTER //
// ./src/config/theme.js